module.exports = __webpack_public_path__ + "static/media/paper_hero_mobile.1a5cc877.jpg";